// src/components/property/display/PropertySummary.js
import React from 'react';
import { useTranslation } from 'react-i18next';
import './PropertySummary.css';
import { formatCurrency } from '../../../utils/currencyFormatter';
import { formatNumber } from '../../../utils/formatting';

const PropertySummary = ({ price, address, city, state, zip, roi, beds, baths, size }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="zillow-main framed-section">
      <div className="property-summary-row">
        <div className="summary-column summary-column-left">
          <span className="zillow-price">{formatCurrency(price)}</span>
          <span className="zillow-address" style={{ direction: 'ltr', textAlign: i18n.dir() === 'rtl' ? 'right' : 'left' }}>
            {address}, {city}, {state} {zip}
          </span>
        </div>

        <div className="summary-column summary-column-center">
          {roi ? (
            <span className="zillow-roi-inline">
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0px' }}>
                <span className="zillow-roi-label">{t('propertySummary.roi')}</span>
                <span className="zillow-roi-value" dangerouslySetInnerHTML={{ __html: roi }} />
              </div>
            </span>
          ) : (
            <span className="zillow-roi-inline">
              <span className="zillow-roi-label">{t('propertySummary.roi')}</span>
              <span className="zillow-roi-value">{t('propertySummary.notAvailable')}</span>
            </span>
          )}
        </div>

        <div className="summary-column summary-column-right">
          <div className="summary-details-numbers">
            <span>{formatNumber(beds) || t('propertySummary.notAvailable')}</span>
            <span>{formatNumber(baths) || t('propertySummary.notAvailable')}</span>
            <span>{formatNumber(size) || t('propertySummary.notAvailable')}</span>
          </div>
          <div className="summary-details-labels">
            <span>{t('propertySummary.beds')}</span>
            <span>{t('propertySummary.baths')}</span>
            <span>{t('propertySummary.sqft')}</span>
          </div>
        </div>
      </div>
      <hr className="summary-separator" />
    </div>
  );
};

export default PropertySummary;
